exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notifications__list {\n  width: 100%;\n  margin-right: 20px;\n  margin-left: 20px; }\n\n.filter-button {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  margin-left: auto; }\n\n.notifications-screen {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 600px;\n  margin-right: auto;\n  margin-left: auto;\n  padding-top: 20px;\n  padding-left: 10px;\n  padding-right: 10px; }\n", ""]);

// exports
